interface BarChartIconProps {
	size?: number | string;
	color?: string;
}

export function BarChartIcon({ size = 16, color }: BarChartIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M13.8182 13.818L3.47643 13.818C3.1331 13.818 2.80382 13.6816 2.56105 13.4388C2.31827 13.1961 2.18188 12.8668 2.18188 12.5235L2.18188 2.18164M5.09098 5.09073L11.6364 5.09073M5.09098 7.99982L13.8182 7.99982M5.09098 10.9089L8.00007 10.9089"
				stroke={color || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
